<template>
  <div class="positions__wrapper d-flex positions__wrapper--border">
    <img class="positions__image" alt="" :src="img_catalog + 's-5.svg'" />
    <div class="d-flex flex-column justify-center" v-if="positions.positions_count">
      <bim-text type=accent>Полный отчет на <b>{{ positions.positions_count }}</b> {{ declOfNum(positions.positions_count, positions_translate) }}</bim-text>
      <div class="d-flex align-center mt-10">
        <bim-button @click="$emit('downloadFull')" size=l label="Запросить полный отчет" class="mr-8" />
        <bim-text type="medium">{{ positions.positions_price }} р.</bim-text>
      </div>
    </div>
    <div v-else class="d-flex flex-column justify-center">
      <bim-text type=main>Позиций для анализа не найдено, загрузите другую смету или скачайте пример</bim-text>
    </div>
  </div>
</template>

<script>
import declOfNum from "@/utils/declOfNum"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "BlockFullPositions",
  props: {
    positions: Object,
  },
  data() {
    return {
      img_catalog,
      positions_translate: ['позиция', 'позиции', 'позиций'],
    }      
  },
  methods: {
    declOfNum,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.positions__wrapper {
  width: 683px;
}
.positions__wrapper--border {
  border: 2px dashed $primary-color;
}
.positions__wrapper--background-gray {
  background: #fafafa;
}
.positions__image {
  margin: 63px 53px;
}
</style>
